import * as kendoThemeChooser from "../KednoThemeChooser";
import * as DashboardConstants from "../../constants/DashboardConstants";
import {getByColName, resultSetSize} from "./DashBoardResultSetUtil";
import {calcChartTitle} from "../highCharts/HighGaugeDrawer";

/**
 *
 * @param {namaTypes.DTOUserDashbordChartLine} userDashboardChartLine
 * @param h
 * @param w
 * @return {JQuery | jQuery | HTMLElement}
 */
export function createCombinationChart(userDashboardChartLine, h, w, widget, chartArea) {
    let title = calcChartTitle(userDashboardChartLine);
    let list = userDashboardChartLine.resultSet;
    let params = userDashboardChartLine.parameters;
    let categs = [];
    let avgValues = [];
    let piePoints = [];
    let labelWithValues = new Map();
    let categParam = params[DashboardConstants.Param_ColumnCategory] || "";
    let labelParam = params[DashboardConstants.Param_ColumnLabel] || "";
    let valueParam = params[DashboardConstants.Param_ColumnValue] || "";
    let pieLabelParam = params[DashboardConstants.Param_PieLabel] || "";
    let pieValueParam = params[DashboardConstants.Param_PieValue] || "";
    let avgParam = params[DashboardConstants.Param_AvgValue] || "";
    let series = [];
    for (let i = 0; i < resultSetSize(list); i++) {
        let categ = getByColName(i, categParam, list);
        if (!categs.contains(categ))
            categs.push(categ);
        let label = getByColName(i, labelParam, list);
        if (!labelWithValues.get(label))
            labelWithValues.set(label, []);
        let value = getByColName(i, valueParam, list);
        labelWithValues.get(label).push(value);
        let avgValue = getByColName(i, avgParam, list);
        avgValues.push(avgValue);
        let x = getByColName(i, pieLabelParam, list);
        let parseDouble = getByColName(i, pieValueParam, list);
        let point = {
            category: x, value: parseDouble
        };
        piePoints[i] = point;
    }
    for (let [label, values] of labelWithValues.entries()) {
        series.push({name: label, type: "column", data: values});
    }
    series.push({name: "Average", type: "line", data: avgValues});
    series.push({name: title, type: "pie", data: piePoints});
    widget.kendoChart({
        theme: kendoThemeChooser.currentTheme(),
        legend: {
            position: "bottom"
        },

        categoryAxis: {
            categories: categs
        },
        series: series,
        chartArea: chartArea,
        tooltip: {
            visible: true,
            format: "{0}%",
            template: "#= category #<br> #= value #"
        }
    });
    return widget;
}